import * as _ from 'lodash-es';
import {FilterCriterion} from './filter-criterion';

export class QueryParamFilterCriterion implements FilterCriterion {
    public queryParamName: string;
    public query: any;

    constructor(options?: {queryParamName?: string, query?: any}) {
        _.assign(this, options);
    }

    public apply(queryParams: {[key: string]: any}): void {
        if (this.isQuerySpecified()) {
            _.set(queryParams, this.queryParamName, this.getPrimitiveQueryValue());
        }
    }

    public getPrimitiveQueryValue(): string {
        return this.query;
    }

    public isQuerySpecified(): boolean {
        const queryString = this.getPrimitiveQueryValue();

        return queryString != null && queryString !== '';
    }
}
